<script setup>
  import { computed, ref } from "vue";

  // import { EXTEND_TIME_OPTIONS } from "@/utils/constant";

  const props = defineProps({
    show: {
      type: Boolean,
      required: true,
    },
    isTotal: {
      type: Boolean,
      required: false,
    },
    nextTour: { type: Function, required: true },
  });

  const emits = defineEmits(["update:show"]);

  const localShow = computed({
    get: () => props.show,
    set: (val) => emits("update:show", val),
  });

  const closeModal = () => {
    emits("update:show", false);
  };

  const extendReason = ref("1");
  const extendTime = ref("5");
  const EXTEND_REASON_OPTIONS = [
    { label: "교사 확인 재응시 처리", value: "1" }
  ];
  const EXTEND_TIME_OPTIONS = [
    { label: "5분", value: "5" }
  ];

  // Tour 처리
  const afterEnter = () => {
    props.nextTour();
  };
  const afterEnter2 = () => {
    emits("update:show", false);
    props.nextTour();
  };

</script>

<template>
  <ui-modal
    v-model:show="localShow"
    :title="isTotal ? '전체 학생 연장' : '시험 시간 추가'"
    size="xs"
    @after-enter="afterEnter"
  >
    <template #body>
      <ui-table variant="bordered">
        <colgroup>
          <col style="width: 100px" />
          <col style="width: auto" />
        </colgroup>
        <tbody>
          <tr>
            <th class="text-center">사유</th>
            <td>
              <n-select
                size="tiny"
                v-model:value="extendReason"
                :options="EXTEND_REASON_OPTIONS"
              />
            </td>
          </tr>
          <tr>
            <th class="text-center">추가시간</th>
            <td>
              <n-select
                size="tiny"
                v-model:value="extendTime"
                :options="EXTEND_TIME_OPTIONS"
              />
            </td>
          </tr>
          <tr v-if="!isTotal">
            <th class="text-center">종료시간</th>
            <td>2025.08.12 16:04</td>
          </tr>
        </tbody>
      </ui-table>
    </template>
    <template #footer>
      <div class="btn-area justify-end">
        <ui-button variant="outlined" color="gray" @click="closeModal"
          >취소
        </ui-button>
        <ui-button id="tour-extend-add-time" @click="afterEnter2">변경</ui-button>
      </div>
    </template>
  </ui-modal>
</template>
